import type { ComponentProps } from "react";
import React from "react";
import { tv } from "tailwind-variants";
import type { VariantProps } from "tailwind-variants";

import { cn } from "@/lib/helpers/cn";

type BadgeProps = ComponentProps<"span"> & VariantProps<typeof badgeStyles>;

export function Badge2({ children, className, size, variant, ...badgeProps }: BadgeProps) {
  const { body } = badgeStyles({ size, variant });

  return (
    <span className={cn(body(), className)} role="status" {...badgeProps}>
      {children}
    </span>
  );
}

const badgeStyles = tv({
  defaultVariants: {
    size: "sm",
    variant: "neutral",
  },
  slots: {
    body: "tw:text-center tw:rounded-sm tw:font-bold tw:uppercase trim-both tw:select-none",
  },
  variants: {
    size: {
      md: {
        body: "tw:h-6 tw:p-1.75 label-sm",
      },
      sm: {
        body: "tw:h-5 tw:p-1.5 label-xs",
      },
      xs: {
        body: "tw:h-4 tw:p-1 label-xs",
      },
    },
    variant: {
      error: {
        body: "tw:bg-fill-error-primary tw:text-text-white",
      },
      navy: {
        body: "tw:bg-fill-navy-primary tw:text-text-white",
      },
      neutral: {
        body: "tw:bg-fill-quinary tw:text-text-secondary ",
      },
      "outline-neutral": {
        body: "tw:border tw:border-fill-quaternary tw:bg-transparent tw:text-text-secondary",
      },
      "outline-success": {
        body: "tw:border tw:border-fill-success-primary tw:bg-transparent tw:text-fill-success-primary",
      },
      success: {
        body: "tw:bg-fill-success-primary tw:text-text-white",
      },
      warning: {
        body: "tw:bg-fill-warning-secondary tw:text-text-secondary",
      },
    },
  },
});
